<template>
  <v-container class="success-page" style="max-width: 600px; margin: 200px auto;">
    <v-card class="status-card" elevation="10">
      <v-card-title class="success-title">
        <v-icon large color="green" class="mr-2">mdi-check-circle</v-icon>
        Registration Successful
      </v-card-title>

      <v-card-text class="text-center mt-4">
        <h2 class="success-heading mb-4">Thank you for registering!</h2>
        
        <!-- Registration Details -->
        <v-card class="details-card mb-4" outlined>
          <v-card-text>
            <div class="detail-item">
              <span class="detail-label">Intern ID:</span>
              <span class="detail-value">{{ userData.intern_id }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Name:</span>
              <span class="detail-value">{{ userData.student_name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Email:</span>
              <span class="detail-value">{{ userData.email }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Internship:</span>
              <span class="detail-value">{{ userData.internship }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Type:</span>
              <span class="detail-value">{{ userData.internship_type }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">UTR Number:</span>
              <span class="detail-value">{{ userData.utr_number }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Payment Date:</span>
              <span class="detail-value">{{ formatDate(userData.payment_date) }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Amount Paid:</span>
              <span class="detail-value">₹{{ userData.already_paid_amount }}</span>
            </div>
          </v-card-text>
        </v-card>

        <p class="info-text mb-4">
          <v-icon small color="info" class="mr-1">mdi-information</v-icon>
          You will receive further instructions and details via email.
        </p>

        <div class="d-flex flex-wrap justify-center">
          <v-btn
            color="primary"
            @click="goToHome"
            elevation="2"
            class="mx-2 mb-2"
          >
            <v-icon left>mdi-home</v-icon>
            Go to Home
          </v-btn>

          <v-btn
            color="success"
            href="https://api.whatsapp.com/send?phone=919618570195"
            target="_blank"
            elevation="2"
            class="mx-2 mb-2"
          >
            <v-icon left>mdi-whatsapp</v-icon>
            Contact Support
          </v-btn>

          <v-btn
            color="success"
            href="https://chat.whatsapp.com/FgAlS3oIUlNEAweswvTbXc"
            target="_blank"
            elevation="2"
            class="mx-2 mb-2"
          >
            <v-icon left>mdi-account-group</v-icon>
            Join Group
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'AlreadyPaidStatus',
  
  data() {
    return {
      userData: this.$route.params.userData || {}
    };
  },

  methods: {
    goToHome() {
      this.$router.push('/');
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
.success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.status-card {
  border-radius: 12px;
  padding: 20px;
  width: 100%;
}

.success-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  color: #4CAF50;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.success-heading {
  color: #2E7D32;
  font-size: 22px;
}

.details-card {
  background-color: #f5f5f5;
  margin: 20px 0;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #e0e0e0;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  color: #666;
  font-weight: 500;
}

.detail-value {
  color: #1976D2;
  font-weight: 600;
}

.info-text {
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-btn {
  min-width: 150px;
}

@media (max-width: 600px) {
  .status-card {
    margin: 10px;
    padding: 15px;
  }

  .detail-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 12px 0;
  }

  .detail-label {
    margin-bottom: 4px;
  }
}
</style>
